import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import AuthEmail from "../views/AuthEmail";
import AuthCode from "../views/AuthCode.vue";

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/auth",
    name: "Auth",
    component: AuthEmail,
  },
  {
    path: "/auth/verification",
    name: "AuthVerification",
    component: AuthCode,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
